import type { StylePart } from '@/features/map';
import type { UnitSystem } from '@/features/units';
import type { Basemap } from './basemapAtom';
import { CONTOURS_SOURCE, contourLayers, contourTilesUrl } from './contours';
import { defaultMapStyle } from './defaultMap';

const SATELLITE_ATTRIBUTION =
  'Imagery © <a href="https://www.esri.com">Esri</a>, Maxar, Earthstar Geographics';

/** The default vector map or satellite imagery, plus DEM contours drawn over either of them. */
export function basemapStyle(basemap: Basemap, units: UnitSystem): StylePart {
  const satellite = basemap === 'satellite';
  const defaultMap = defaultMapStyle(!satellite);
  return {
    sprite: defaultMap.sprite,
    sources: {
      ...defaultMap.sources,
      satellite: {
        type: 'raster',
        tiles: [
          'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        ],
        tileSize: 256,
        maxzoom: 19,
        attribution: SATELLITE_ATTRIBUTION,
      },
      [CONTOURS_SOURCE]: { type: 'vector', tiles: [contourTilesUrl(units)], maxzoom: 15 },
    },
    layers: [
      ...defaultMap.layers!,
      {
        id: 'satellite',
        type: 'raster',
        source: 'satellite',
        layout: { visibility: satellite ? 'visible' : 'none' },
      },
      ...contourLayers(units, basemap),
    ],
  };
}
